import { render, staticRenderFns } from "./recipe-instructions.vue?vue&type=template&id=28287da3&"
import script from "./recipe-instructions.vue?vue&type=script&lang=js&"
export * from "./recipe-instructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports